(function(){
'use strict';

scFundraisingTeamSearchModel.$inject = ["scResourceSearchModel"];
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scFundraisingTeamSearchModel(scResourceSearchModel) {
  return function (_scResourceSearchMode) {
    _inherits(FundraisingTeamSearchModel, _scResourceSearchMode);

    function FundraisingTeamSearchModel(fields, queryParams) {
      _classCallCheck(this, FundraisingTeamSearchModel);

      return _possibleConstructorReturn(this, (FundraisingTeamSearchModel.__proto__ || Object.getPrototypeOf(FundraisingTeamSearchModel)).call(this, 'fundraising-teams', fields, queryParams));
    }

    /**
     * {@inheritdoc}
     */


    _createClass(FundraisingTeamSearchModel, [{
      key: 'getReadableTypeName',
      value: function getReadableTypeName() {
        return 'teams';
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getLogo',
      value: function getLogo(resource) {
        return _.get(resource, 'logo.asset.src', _.get(resource, 'logo.cdn_url', '/static/global/images/team_default_image.png'));
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getName',
      value: function getName(resource) {
        return resource.name;
      }
    }]);

    return FundraisingTeamSearchModel;
  }(scResourceSearchModel);
}

angular.module('classy').factory('scFundraisingTeamSearchModel', scFundraisingTeamSearchModel);
})();